export default __webpack_public_path__ + "static/media/show.c8fbae6f.svg";